"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AllergyLineResultSchema () {
        return AllergyLineResultSchema;
    },
    get PrescriptionAllergyAcknowledgementsSchema () {
        return PrescriptionAllergyAcknowledgementsSchema;
    },
    get PrescriptionAllergyCheckSchema () {
        return PrescriptionAllergyCheckSchema;
    },
    get PrescriptionAllergyLineSchema () {
        return PrescriptionAllergyLineSchema;
    },
    get PrescriptionIssuedAllergyCheckSchema () {
        return PrescriptionIssuedAllergyCheckSchema;
    }
});
const _zod = require("zod");
const _prescriptionstatus = require("./prescription-status");
const _prescriptiontext = require("./prescription-text");
const _allergystatus = require("../patients/allergy-status");
const AllergyLineResultSchema = _zod.z.enum([
    'clear',
    'conflict',
    'name_only'
]);
const PrescriptionAllergyLineSchema = _zod.z.object({
    position: _zod.z.number().int().min(1).max(_prescriptionstatus.PRESCRIPTION_LIMITS.itemsMax),
    result: AllergyLineResultSchema,
    matchedAllergies: _zod.z.array(_zod.z.string())
}).strict();
const allergyCheckShape = {
    allergyStatus: _allergystatus.AllergyStatusSchema,
    allergies: _zod.z.array(_zod.z.string()),
    /** The patient's allergy CAS token; the issue request echoes it back. */ allergyRecordedAt: (0, _prescriptiontext.isoDateTime)().nullable(),
    lines: _zod.z.array(PrescriptionAllergyLineSchema).max(_prescriptionstatus.PRESCRIPTION_LIMITS.itemsMax),
    conflictCount: _zod.z.number().int().min(0),
    nameOnlyCount: _zod.z.number().int().min(0)
};
const PrescriptionAllergyCheckSchema = _zod.z.object(allergyCheckShape).strict();
const PrescriptionAllergyAcknowledgementsSchema = _zod.z.object({
    unknownAllergyStatus: _zod.z.boolean(),
    nameOnlyLines: _zod.z.boolean()
}).strict();
const PrescriptionIssuedAllergyCheckSchema = _zod.z.object({
    ...allergyCheckShape,
    acknowledgements: PrescriptionAllergyAcknowledgementsSchema
}).strict();
